export default __webpack_public_path__ + "static/media/circle-green.6374af35.svg";